import { Link } from "react-router-dom";
import bionividLogo from "@/assets/images/bionivid-logo.png";
export default function Logo({
  className = "",
  brand = "sqit",
  size = "default",
  version = null
}) {
  const isSmall = size === "small";

  const titleClass = isSmall
    ? "text-2xl md:text-3xl"
    : "text-4xl md:text-5xl";

  const tmClass = isSmall
    ? "text-xs md:text-sm"
    : "text-sm md:text-base";

  switch (brand) {
    case "bionivid":
      return (
        <div className={`flex items-center ${className}`}>
          {/* Bionivid logo -> opens bionivid.in */}
          <a
            href="https://www.bionivid.in"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center"
          >
            <img
              src={bionividLogo}
              alt="Bionivid"
              className="h-10 w-auto"
            />
          </a>

          {/* BIOINFO -> goes to homepage */}
          <Link
            to="/"
            className={`ml-2 text-[#34492B] font-black tracking-tight leading-none ${titleClass}`}
          >
            BIOINFO
          </Link>
        </div>
      );

    case "saas":
      return (
        <div className={`flex items-end ${className}`}>
          <h1 className="font-black tracking-tight leading-none">
            <span className="text-black text-4xl md:text-5xl">
              SQIT
            </span>

            <span className="text-[#34492B] text-4xl md:text-5xl">
              .ai
            </span>

            <sup className="ml-1 text-sm md:text-base font-medium text-black align-top">
              TM
            </sup>

            <span className="ml-3 text-[#34492B] text-4xl md:text-5xl font-black">
              SaaS
            </span>

            <span className="ml-2 text-black text-4xl md:text-5xl font-black">
              Platform
            </span>
          </h1>
        </div>
      );

    default:
      return (
        <div className={`flex flex-col items-center ${className}`}>
          <div className="flex items-start">
            <h1 className="font-black tracking-tight leading-none">
              <span className="text-black text-4xl md:text-5xl">
                SQIT
              </span>
              <span className="text-[#34492B] text-4xl md:text-5xl">
                .ai
              </span>
              <sup className="ml-1 text-sm md:text-base font-medium text-black">
                TM
              </sup>
            </h1>
          </div>

          {version && (
            <span className="mt-1 text-[11px] font-medium tracking-wide text-black">
              {version}
            </span>
          )}
        </div>
      );
  }
}